import IllustrationAICPA from '@picsart/illustrations/IllustrationAICPA';
import classnames from 'classnames';
import { L as LogoAndLanguageSwitcher, C as CopyRight } from '../../CopyRight-a9a10613.js';
import navigationItems from '../../navigationItems/index.js';
import FooterRelevantLinks from '../../FooterRelevantLinks/index.js';
import { e as externalLinksData, c as changesNeedLocales } from '../../constants-058c946f.js';
import { createUseStyles } from 'react-jss';
import { useState, useCallback, useEffect } from 'react';
import '@picsart/cascade/styleHelpers/initFavIcons';
import { t as theme } from '../../styles-2f14f8fb.js';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import '@picsart/rc/useMount';
import '@picsart/cascade/colors/themes';
import { _ as _defineProperty } from '../../defineProperty-377d5a7f.js';
import { canHover } from '@picsart/cascade/styleHelpers/hoverTouch';
import { isLeftToRight, isRightToLeft } from '@picsart/cascade/styleHelpers/rtl';
import { _ as _slicedToArray } from '../../slicedToArray-b4278ecd.js';
import { _ as _extends, a as _objectDestructuringEmpty } from '../../extends-1919b7d2.js';
import footerNavigation from '../../footerNavigation/index.js';
import useGeoZone from '../../useGeozone/index.js';
import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-a0edb288.js';
import { useTranslator } from '@picsart/rc/services/localization';
import IconArrowDownSmall from '@picsart/icons/IconArrowDownSmall';
import textOverflowHidden from '@picsart/cascade/styleHelpers/textOverflowHidden';
import { R as RestrictedGeoZones } from '../../constants-d756cbb3.js';
import getMobileOperatingSystem from '@picsart/rc/getMobileOperatingSystem';
import IllustrationGetIfFromAppleStore from '@picsart/illustrations/IllustrationGetIfFromAppleStore';
import IllustrationGetItFromGooglePlay from '@picsart/illustrations/IllustrationGetItFromGooglePlay';
import IllustrationGetItFromMicrosoft from '@picsart/illustrations/IllustrationGetItFromMicrosoft';

var useStyles$6 = createUseStyles(function (_ref) {
  var spacings = _ref.spacings,
    radiuses = _ref.radiuses,
    colors = _ref.colors,
    timings = _ref.timings,
    easings = _ref.easings;
  return {
    root: {
      marginTop: spacings.s32,
      textAlign: 'center'
    },
    link: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      display: 'inline-block',
      verticalAlign: 'top',
      width: 24,
      height: 24,
      borderRadius: radiuses.circle,
      // TODO replace when this color is refined
      backgroundColor: '#32343b',
      position: 'relative',
      fontSize: 0
    }, isLeftToRight(), {
      marginRight: spacings.s12
    }), isRightToLeft(), {
      marginLeft: spacings.s12
    }), '&:active', {
      '& > $icon': {
        '& > svg': {
          '& > path': {
            fill: colors.accents.primary.base["default"]
          }
        }
      }
    }), '&:last-child', {
      margin: spacings.s0
    }), canHover(), {
      '&:hover': {
        '& > svg': {
          transition: "fill ".concat(timings.Default, " ").concat(easings.EaseInOut),
          fill: colors.accents.primary.base["default"]
        }
      }
    }),
    icon: {
      display: 'inline-block',
      width: 16,
      height: 16,
      position: 'absolute',
      top: spacings.s0,
      right: spacings.s0,
      bottom: spacings.s0,
      left: spacings.s0,
      margin: 'auto',
      '& > svg': {
        '& > path': {
          transition: "fill ".concat(timings.Default, " ").concat(easings.EaseInOut),
          fill: colors.texts.positive
        }
      }
    }
  };
}, {
  name: 'external-links-mobile'
});

function ExternalLinks() {
  var styles = useStyles$6();
  return /*#__PURE__*/jsx("div", {
    className: styles.root,
    children: externalLinksData.map(function (item) {
      var _item$component;
      var SocialCascadeIcon = (_item$component = item === null || item === void 0 ? void 0 : item.component) !== null && _item$component !== void 0 ? _item$component : /*#__PURE__*/jsx(Fragment, {});
      return /*#__PURE__*/jsxs("a", {
        className: styles.link,
        href: item.url,
        "data-test": item.dataTest,
        "aria-label": item.ariaLabel,
        target: "_blank",
        rel: "noreferrer noopener",
        children: [/*#__PURE__*/jsx(SocialCascadeIcon, {
          "aria-hidden": true,
          className: styles.icon,
          fill: theme.colors.texts.positive
        }), item.name]
      }, item.name);
    })
  });
}

function ownKeys$3(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$5 = createUseStyles(function (_ref) {
  var spacings = _ref.spacings,
    fontWeights = _ref.fontWeights,
    fontSizes = _ref.fontSizes,
    lineHeights = _ref.lineHeights,
    colors = _ref.colors,
    timings = _ref.timings,
    easings = _ref.easings;
  return {
    root: _objectSpread$3(_objectSpread$3({
      display: 'block',
      height: 56,
      fontWeight: fontWeights.Medium,
      fontSize: fontSizes.s16,
      lineHeight: lineHeights.l50,
      color: colors.texts.positive,
      transition: "background-color ".concat(timings.Default, " ").concat(easings.EaseInOut)
    }, textOverflowHidden), {}, {
      '&:first-letter': {
        textTransform: 'capitalize'
      },
      '&.button': _defineProperty(_defineProperty({
        width: '100%',
        border: 'none',
        outline: 'none',
        backgroundColor: 'transparent',
        position: 'relative',
        textAlign: 'initial'
      }, isLeftToRight(), {
        padding: [spacings.s0, spacings.s56, spacings.s0, spacings.s24]
      }), isRightToLeft(), {
        padding: [spacings.s0, spacings.s24, spacings.s0, spacings.s56]
      }),
      '&.link': {
        padding: [spacings.s0, spacings.s24]
      },
      '&:active': {
        // TODO replace when this color is refined
        backgroundColor: '#282B36'
      },
      '&.active': {
        // TODO replace when this color is refined
        backgroundColor: '#282B36',
        '& > $icon': {
          transform: 'rotate(180deg)'
        }
      }
    }),
    icon: _defineProperty(_defineProperty({
      display: 'inline-block',
      width: 24,
      height: 24,
      position: 'absolute',
      top: spacings.s0,
      bottom: spacings.s0,
      margin: ['auto', spacings.s0],
      transition: "transform ".concat(timings.Default, " ").concat(easings.EaseInOut),
      fill: colors.texts.positive
    }, isLeftToRight(), {
      right: spacings.s16
    }), isRightToLeft(), {
      left: spacings.s16
    })
  };
}, {
  name: 'navigation-head'
});

function NavigationHead(_ref) {
  var title = _ref.title,
    isList = _ref.isList,
    isActive = _ref.isActive,
    toggleHandler = _ref.toggleHandler;
  var styles = useStyles$5();
  var translate = useTranslator();
  return isList ? /*#__PURE__*/jsxs("button", {
    className: classnames(styles.root, 'button', {
      active: isActive
    }),
    type: "button",
    onClick: toggleHandler,
    children: [translate(title), /*#__PURE__*/jsx(IconArrowDownSmall, {
      fill: theme.colors.texts.positive,
      className: styles.icon
    })]
  }) : /*#__PURE__*/jsx("div", {
    className: classnames(styles.root, 'link'),
    children: translate(title)
  });
}

function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$4 = createUseStyles(function (_ref) {
  var spacings = _ref.spacings,
    timings = _ref.timings,
    easings = _ref.easings,
    fontWeights = _ref.fontWeights,
    fontSizes = _ref.fontSizes,
    lineHeights = _ref.lineHeights,
    colors = _ref.colors;
  return {
    root: {
      listStyleType: 'none',
      // TODO Need to set correct type
      maxHeight: function maxHeight(props) {
        return props.isActive ? 500 : 0;
      },
      transition: "max-height ".concat(timings.Default, " ").concat(easings.EaseInOut),
      overflow: 'hidden'
    },
    item: {
      marginBottom: spacings.s2,
      '&:last-child': {
        marginBottom: spacings.s0
      }
    },
    link: _objectSpread$2({
      display: 'block',
      height: 56,
      padding: [spacings.s0, spacings.s24],
      fontWeight: fontWeights.Medium,
      fontSize: fontSizes.s14,
      color: colors.texts.positive,
      lineHeight: lineHeights.l50
    }, textOverflowHidden)
  };
}, {
  name: 'nav-list'
});

function NavigationList(_ref) {
  var groupList = _ref.groupList,
    isActive = _ref.isActive,
    countryCode = _ref.countryCode;
  // TODO Need to set correct type
  var styles = useStyles$4({
    isActive: isActive
  });
  var translate = useTranslator();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    korea = _useState2[0],
    setKorea = _useState2[1];
  useGeoZone(function (geoZone) {
    setKorea(geoZone === RestrictedGeoZones.SouthKorea);
  });
  return /*#__PURE__*/jsx("ul", {
    className: styles.root,
    children: groupList.map(function (item) {
      var urlWithCountryCode = countryCode && item.withCountryCode ? "/".concat(countryCode) : '';
      var koreaLink = item.label === 'Privacy Policy' && korea;
      return /*#__PURE__*/jsx("li", {
        className: styles.item,
        children: /*#__PURE__*/jsx("a", {
          className: classnames(styles.link, koreaLink && 'korea-link'),
          href: "".concat(urlWithCountryCode).concat(item.url),
          children: koreaLink ? '개인정보 처리방침' : translate(item.label)
        })
      }, item.label);
    })
  });
}

var useStyles$3 = createUseStyles(function (_ref) {
  var timings = _ref.timings,
    easings = _ref.easings;
  return {
    root: {
      transition: "background-color ".concat(timings.Default, " ").concat(easings.EaseInOut),
      '&.active': {
        // TODO replace when this color is refined
        backgroundColor: '#1E2129'
      }
    }
  };
}, {
  name: 'nav-item'
});

var _excluded = ["title", "groupList", "isList"];
function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function NavigationItem(_ref) {
  var title = _ref.title,
    groupList = _ref.groupList,
    _ref$isList = _ref.isList,
    isList = _ref$isList === void 0 ? true : _ref$isList,
    props = _objectWithoutProperties(_ref, _excluded);
  var styles = useStyles$3();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isActive = _useState2[0],
    setIsActive = _useState2[1];
  var toggleIsVisible = useCallback(function () {
    setIsActive(function (isActive) {
      return !isActive;
    });
  }, []);
  return /*#__PURE__*/jsxs("div", {
    className: classnames(styles.root, {
      active: isList && isActive
    }),
    children: [/*#__PURE__*/jsx(NavigationHead, {
      title: title,
      isActive: isActive,
      toggleHandler: toggleIsVisible,
      isList: isList
    }), isList && /*#__PURE__*/jsx(NavigationList, _objectSpread$1({
      groupList: groupList,
      isActive: isActive
    }, props))]
  });
}

var useStyles$2 = createUseStyles(function (_ref) {
  var spacings = _ref.spacings;
  return {
    root: {},
    itemHolder: {
      marginBottom: spacings.s2,
      '&:last-child': {
        marginBottom: spacings.s0
      }
    }
  };
}, {
  name: 'nav-footer-mobile'
});

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function Navigation(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    country = _useState2[0],
    setCountry = _useState2[1];
  useGeoZone(function (geoZone) {
    setCountry(geoZone);
  });
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    footerNavItems = _useState4[0],
    setFooterNavItems = _useState4[1];
  var styles = useStyles$2();
  useEffect(function () {
    if (country && changesNeedLocales.includes(country)) {
      var newState = JSON.parse(JSON.stringify(footerNavigation));
      var updatedNavLinks = newState.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          groupList: item === null || item === void 0 ? void 0 : item.groupList.map(function (element) {
            var _element$localisedLab;
            if (element !== null && element !== void 0 && (_element$localisedLab = element.localisedLabels) !== null && _element$localisedLab !== void 0 && _element$localisedLab[country]) {
              return _objectSpread(_objectSpread({}, element), {}, {
                label: element.localisedLabels[country]
              });
            }
            return element;
          })
        });
      });
      setFooterNavItems(updatedNavLinks);
    } else {
      setFooterNavItems(footerNavigation);
    }
  }, [country]);
  return /*#__PURE__*/jsx("div", {
    className: styles.root,
    "data-testid": "footer-legal-navigation-mobile",
    children: footerNavItems && footerNavItems.map(function (item) {
      return /*#__PURE__*/jsx("div", {
        className: styles.itemHolder,
        children: /*#__PURE__*/jsx(NavigationItem, _objectSpread({
          title: item.groupLabel,
          groupList: item.groupList || [],
          isList: true
        }, props))
      }, item.groupLabel);
    })
  });
}

// @ts-ignore
var operatingSystem = {
  iOS: {
    name: 'iOS',
    url: 'https://apps.apple.com/us/app/picsart-photo-studio/id587366035',
    iconName: 'get-it-from-app-store-brand',
    className: 'appleIcon',
    ariaLabel: 'IOS App Icon',
    component: IllustrationGetIfFromAppleStore
  },
  WindowsPhone: {
    name: 'WindowsPhone',
    url: 'https://www.microsoft.com/en-us/store/p/picsart-photo-studio/9wzdncrfj10m',
    iconName: 'get-it-from-microsoft-brand',
    className: 'googlePlayIcon',
    ariaLabel: 'Windows App Icon',
    component: IllustrationGetItFromMicrosoft
  },
  Android: {
    name: 'Android',
    url: 'https://play.google.com/store/apps/details?id=com.picsart.studio',
    iconName: 'get-it-from-google-play-brand',
    className: 'microsoftIcon',
    ariaLabel: 'Android App Icon',
    component: IllustrationGetItFromGooglePlay
  }
};

var useStyles$1 = createUseStyles(function (_ref) {
  var spacings = _ref.spacings,
    fontSizes = _ref.fontSizes,
    fontWeights = _ref.fontWeights,
    lineHeights = _ref.lineHeights,
    colors = _ref.colors,
    timings = _ref.timings,
    easings = _ref.easings,
    radiuses = _ref.radiuses;
  return {
    root: {
      marginTop: spacings.s32,
      display: 'flex',
      alignItems: 'center',
      padding: function padding(props) {
        return props.isMobile && [spacings.s0, spacings.s24];
      }
    },
    getTheApp: {
      display: 'inline-block',
      position: 'relative',
      fontWeight: fontWeights.SemiBold,
      fontSize: fontSizes.s14,
      color: colors.texts.positive,
      lineHeight: lineHeights.l32,
      transitionProperty: 'background-color, color, border',
      transitionDuration: timings.Default,
      transitionTimingFunction: easings.EaseInOut,
      margin: [spacings.s0, spacings.s32],
      textTransform: 'uppercase',
      '&:before': {
        content: "''",
        display: 'block',
        position: 'absolute',
        top: -1,
        right: -1,
        bottom: -1,
        left: -1,
        zIndex: -1,
        margin: 'auto',
        borderWidth: 2,
        borderStyle: 'solid',
        borderColor: colors.texts.positive,
        borderRadius: radiuses.r8,
        opacity: 0,
        transitionProperty: 'opacity, top, right, bottom, left',
        transitionDuration: timings.Fast,
        transitionTimingFunction: easings.EaseInOut,
        transform: 'translate3d(0, 0, 0)'
      },
      '&:active': {
        backgroundColor: colors.backgrounds.positive,
        // TODO replace when this color is refined
        borderColor: '#282B36',
        color: '#282B36',
        '&:before': {
          top: -4,
          right: -4,
          bottom: -4,
          left: -4,
          zIndex: 'initial',
          opacity: 1
        }
      }
    },
    icon: {
      display: 'inline-block',
      verticalAlign: 'top',
      height: spacings.s16,
      top: spacings.s0,
      bottom: spacings.s0,
      margin: ['auto', spacings.s0],
      transition: "fill ".concat(timings.Default, " ").concat(easings.EaseInOut),
      '&.appleIcon': {
        width: 91
      },
      '&.microsoftIcon': {
        width: 88
      },
      '&.googlePlayIcon': {
        width: 103
      }
    }
  };
}, {
  name: 'platforms-mobile'
});

function Platform(_ref) {
  var isMobile = _ref.isMobile;
  var styles = useStyles$1({
    isMobile: isMobile
  });
  var translate = useTranslator();
  var mobileType = getMobileOperatingSystem(null);
  var _operatingSystem = operatingSystem[mobileType || 'iOS'],
    url = _operatingSystem.url,
    className = _operatingSystem.className,
    ariaLabel = _operatingSystem.ariaLabel,
    component = _operatingSystem.component;
  var AppStoreLinkIllustration = component;
  return /*#__PURE__*/jsxs("div", {
    "data-yannis": true,
    className: styles.root,
    children: [/*#__PURE__*/jsx("span", {
      className: styles.getTheApp,
      "data-test": "get-free-app-hypertext",
      children: translate('GET THE FREE APP')
    }), /*#__PURE__*/jsx("a", {
      href: url,
      "data-test": "get-free-app-hypertext",
      children: /*#__PURE__*/jsx(AppStoreLinkIllustration, {
        fill: "none",
        className: classnames(styles.icon, className),
        "aria-label": ariaLabel
      })
    })]
  });
}

var useStyles = createUseStyles(function (_ref) {
  var spacings = _ref.spacings;
  return {
    root: {
      width: '100%',
      textDecoration: 'none'
    },
    section: {
      '&.top': {
        padding: [spacings.s44, spacings.s0, spacings.s56, spacings.s0],
        // TODO replace when this color is refined
        backgroundColor: '#282B36'
      },
      '&.bottom': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 56,
        // TODO replace when this color is refined
        backgroundColor: '#1E2129'
      }
    },
    externalLinksHolder: {
      marginTop: spacings.s32
    },
    aicpaIcon: {
      display: 'block',
      marginLeft: spacings.s24,
      marginTop: spacings.s32,
      marginBottom: spacings.s24,
      width: 70,
      height: 70,
      '& > svg': {
        width: '100%',
        height: '100%'
      }
    }
  };
}, {
  name: 'footer-mobile'
});

// @ts-ignore
function Mobile(_ref) {
  var countryCode = _ref.countryCode,
    isSingleLanguage = _ref.isSingleLanguage,
    _ref$relevantLinkEnab = _ref.relevantLinkEnabled,
    relevantLinkEnabled = _ref$relevantLinkEnab === void 0 ? true : _ref$relevantLinkEnab;
  var styles = useStyles();
  return /*#__PURE__*/jsxs("div", {
    children: [relevantLinkEnabled && /*#__PURE__*/jsx(FooterRelevantLinks, {}), /*#__PURE__*/jsxs("footer", {
      className: styles.root,
      id: "footer-mobile",
      "data-testid": "footer-mobile",
      children: [/*#__PURE__*/jsxs("section", {
        className: classnames(styles.section, 'top'),
        children: [/*#__PURE__*/jsx(LogoAndLanguageSwitcher, {
          isMobile: true,
          isSingleLanguage: isSingleLanguage
        }), /*#__PURE__*/jsx(Platform, {
          isMobile: true
        }), /*#__PURE__*/jsx("a", {
          href: "".concat(navigationItems.aicpa.url),
          className: styles.aicpaIcon,
          children: /*#__PURE__*/jsx(IllustrationAICPA, {})
        }), /*#__PURE__*/jsx(Navigation, {
          countryCode: countryCode
        }), /*#__PURE__*/jsx(ExternalLinks, {})]
      }), /*#__PURE__*/jsx("section", {
        className: classnames(styles.section, 'bottom'),
        children: /*#__PURE__*/jsx(CopyRight, {})
      })]
    })]
  });
}

export { Mobile as default };
//# sourceMappingURL=index.js.map
